export default __webpack_public_path__ + "static/media/uploader-trivia-2.af6ce708.png";